export enum FunctionType {
    iDisplay = 0,
    mDisplay = 1,
    wDisplay = 2
}
